import * as Yup from 'yup';

const schema = Yup.object({
  email: Yup.string().required('Required').email('Please enter a valid email.'),
  password: Yup.string().required('Required'),
});

export default schema;
